import { render } from "./ImportNarrativebookModal.vue?vue&type=template&id=255eabab&scoped=true"
import script from "./ImportNarrativebookModal.vue?vue&type=script&lang=js"
export * from "./ImportNarrativebookModal.vue?vue&type=script&lang=js"

import "./ImportNarrativebookModal.vue?vue&type=style&index=0&id=255eabab&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255eabab"]])

export default __exports__